module.exports = __webpack_public_path__ + "static/media/financeira_brb_vertical_preferencial-branca.6c2072e5.png";